import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-clear",
  "use": "icon-clear-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-clear\"><path d=\"M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0zm2.843 8.96a.624.624 0 0 1-.882.883L7 7.883l-1.96 1.96a.623.623 0 1 1-.883-.883L6.117 7l-1.96-1.96a.624.624 0 1 1 .884-.883L7 6.117l1.96-1.96a.624.624 0 1 1 .883.884L7.883 7l1.96 1.96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/clear.svg
// module id = 4KGF
// module chunks = 28